// Fix missing ETG exams.
window.closeCustomerLastExam = () => {
  window.setCookie('customer-last-exam', 1, 3600);
}

$(() => {
  setTimeout(() => {
    let qs = null,
      regs = window.location.pathname.match(/\/admin\/users\/([0-9]+)/);
    if (regs && regs.length == 2) {
      qs = `user_id=${regs[1]}`;
    }

    if (qs || /\/u\/c/.test(window.location.pathname)) {
      axios.get(`/xhr/synch-etg-exams?${qs}`)
        .then(response => {
          // console.error('ua', response.data)
          // console.error(response);


        })
        .catch(error => {
          console.error('error', error);
        });
    }
  }, 4000);

  if (!window.getCookie('customer-last-exam')) {
    $('#customer-last-exam').show();
  }
});